import React, {ChangeEvent, Component, FormEvent, RefObject} from "react";
import ScrollAnimation from "react-animate-on-scroll";
import {ApplicationFormProps} from "../../../../models/BannerModel";
import './ApplicationForm.scss';
import axiosClient from "../../../../config/AxiosRestClient";
import LoaderButton from "../../../../components/LoaderButton";
import toast from "react-hot-toast";
import applicationFormImg from "../../../../assets/css/images/ApplicationForm.jpeg";
import logo from "../../../../assets/css/images/LOGO 2.jpg";
import axios from 'axios';

interface ApplicationFormBscState {
    usermessage?: UserMessage,
    processing: boolean,
    messageSent: boolean,
    studentName: string,
    fatherName: string,
    email: string,
    passOutClass: string,
    schoolName: string,
    mobile: any,
    address: string,
    city: string,
    state: string,
    admitCardURL: string,
    formId: number | null;
    selectedState: string;
    cities: string[];
    applicationFormId: number | null;
}

interface UserMessage {
    message: string
    type: string
}

class ApplicationForm extends Component<ApplicationFormProps, ApplicationFormBscState> {
    stateCityData: Record<string, string[]> = {
        'Andhra Pradesh': ['Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Others'],
        'Arunachal Pradesh': ['Itanagar', 'Tawang', 'Ziro', 'Pasighat', 'Others'],
        'Assam': ['Guwahati', 'Dibrugarh', 'Silchar', 'Jorhat', 'Others'],
        'Bihar': ['Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Darbhanga', 'Bihar Sharif', 'Others'],
        'Chhattisgarh': ['Raipur', 'Bhilai', 'Bilaspur', 'Durg', 'Others'],
        'Delhi': [
            'New Delhi', 'Central Delhi', 'North Delhi', 'South Delhi',
            'East Delhi', 'West Delhi', 'Shahdara', 'Dwarka',
            'Rohini', 'Narela', 'Karol Bagh', 'Others'
        ],
        'Goa': ['Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Others'],
        'Gujarat': ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Gandhinagar', 'Others'],
        'Haryana': ['Gurugram', 'Faridabad', 'Panipat', 'Ambala', 'Others'],
        'Himachal Pradesh': ['Shimla', 'Manali', 'Dharamshala', 'Solan', 'Others'],
        'Jharkhand': ['Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Others'],
        'Karnataka': ['Bangalore', 'Mysore', 'Mangalore', 'Hubli', 'Belgaum', 'Others'],
        'Kerala': ['Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Thrissur', 'Others'],
        'Madhya Pradesh': ['Bhopal', 'Indore', 'Gwalior', 'Jabalpur', 'Others'],
        'Maharashtra': [
            'Mumbai', 'Pune', 'Nagpur', 'Nashik', 'Thane',
            'Aurangabad', 'Solapur', 'Amravati', 'Others'
        ],
        'Manipur': ['Imphal', 'Thoubal', 'Bishnupur', 'Churachandpur', 'Others'],
        'Meghalaya': ['Shillong', 'Tura', 'Nongpoh', 'Jowai', 'Others'],
        'Mizoram': ['Aizawl', 'Lunglei', 'Saiha', 'Champhai', 'Others'],
        'Nagaland': ['Kohima', 'Dimapur', 'Mokokchung', 'Tuensang', 'Others'],
        'Odisha': ['Bhubaneswar', 'Cuttack', 'Rourkela', 'Puri', 'Others'],
        'Punjab': ['Chandigarh', 'Ludhiana', 'Amritsar', 'Jalandhar', 'Others'],
        'Rajasthan': ['Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Others'],
        'Sikkim': ['Gangtok', 'Namchi', 'Geyzing', 'Mangan', 'Others'],
        'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirapalli', 'Others'],
        'Telangana': ['Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar', 'Others'],
        'Tripura': ['Agartala', 'Udaipur', 'Dharmanagar', 'Kailashahar', 'Others'],
        'Uttar Pradesh': [
            'Agra', 'Mathura', 'Allahabad', 'Lucknow', 'Kanpur',
            'Jhansi', 'Meerut', 'Aligarh', 'Ghaziabad', 'Etah',
            'Firozabad', 'Mainpuri', 'Gwalior', 'Greater Noida',
            'Kasganj', 'Hathras', 'Others'
        ],

        'Uttarakhand': ['Dehradun', 'Haridwar', 'Rishikesh', 'Haldwani', 'Others'],
        'West Bengal': ['Kolkata', 'Howrah', 'Durgapur', 'Asansol', 'Others']
    };
    form: RefObject<HTMLFormElement>

    constructor(props: ApplicationFormProps) {
        super(props);
        this.state = {
            processing: false,
            messageSent: false,
            studentName: '',
            fatherName: '',
            email: '',
            passOutClass: '',
            schoolName: '',
            mobile: '',
            address: '',
            city: '',
            state: '',
            admitCardURL: '',
            formId: null,
            selectedState: '',
            cities: [],
            applicationFormId:null,
        }

        console.log('#48', this.state)
        this.form = React.createRef();
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event: any) {
        // const {studentName, value} = event.target;
        const target = event.target;
        const name = target.name;
        const value = this.extractEventValue(target);
        this.setState({
            ...this.state,
            [name]: value
        });
    }

// Handle state change
    handleStateChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const selectedState = e.target.value;
        this.setState({
            selectedState,
            state: selectedState,       // ✅ Store in the state field
            cities: this.stateCityData[selectedState] || [],
            city: ''                    // Reset city when changing state
        });
    };
// Handle city change
    handleCityChange = (e: ChangeEvent<HTMLSelectElement>) => {
        this.setState({ city: e.target.value });  // ✅ Store city in the form state
    };
    private extractEventValue(target: any) {
        if (target.type === 'checkbox') {
            return target.checked;
        } else if (target.type === 'file') {
            return target.files!![0];
        } else {
            return target.value;
        }
    }

    getPayload = (): any => {
        const payload = {
            'studentName': this.state.studentName,
            'fatherName': this.state.fatherName,
            'email': this.state.email,
            'mobile': this.state.mobile,
            'passOutClass': this.state.passOutClass,
            'schoolName': this.state.schoolName,
            'address': this.state.address,
            'city': this.state.city,
            'state': this.state.state,
        }
        console.log('#190',payload)
        return payload;
    }




    applicantUser = () => {
        this.setState({processing: true});

        axiosClient.post(`/listingfy-service/application-form`, this.getPayload())
            .then((res) => {
                if (res.status === 200) {
                    toast.success('Form submitted successfully');
                    this.setState({
                        processing: false, messageSent: true,
                        admitCardURL: res.data.admitCardURL,
                        applicationFormId:res.data.id
                    });
                    console.log('Admit Card URL:', res.data.admitCardURL);
                } else {
                    this.setState({
                        usermessage: {
                            message: "Unknown error sending application form: " + res.status,
                            type: "error"
                        }
                    });
                    this.setState({processing: false, messageSent: false});
                }
            })
            .catch((error: any) => {
                console.log("#90 Application Form:", error);
                if (error.response) {
                    // Handle known status codes
                    switch (error.response.status) {
                        case 400:
                            toast.error('Form already submitted by user');
                            break;
                        case 401:
                            toast.error('Unauthorized access. Please log in.');
                            break;
                        case 403:
                            toast.error('You do not have permission to submit this form.');
                            break;
                        case 404:
                            toast.error('Service not found. Please try again later.');
                            break;
                        case 500:
                            toast.error('Server error. Please try again later.');
                            break;
                        default:
                            toast.error(`Unexpected error: ${error.response.status}`);
                            break;
                    }
                } else if (error.request) {
                    // No response from server
                    toast.error('No response from server. Please check your internet connection.');
                } else {
                    // Something went wrong in setting up the request
                    toast.error(`Error submitting form: ${error.message}`);
                }
                this.setState({processing: false, messageSent: false});
            });
    };

    submitApplicantForm = (event: FormEvent) => {
        event.preventDefault();
        this.applicantUser();
    }


    downloadAdmitCard = () => {
        const { applicationFormId, studentName } = this.state;

        if (!applicationFormId) {
            console.error("Form ID is required to download the admit card");
            return;
        }

        axiosClient
            .post(`listingfy-service/application-form/${applicationFormId}/download`, {}, {
                responseType: 'json',
            })
            .then((response) => {
                const fileUrl = response.data.url;
                if (!fileUrl) {
                    console.error("No URL found in the response");
                    return;
                }

                axios.get(fileUrl, {
                    responseType: 'blob',
                })
                    .then((fileResponse) => {
                        const blob = new Blob([fileResponse.data], { type: fileResponse.headers['content-type'] });

                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `AdmitCard_${studentName || 'User'}.pdf`);
                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    })
                    .catch((fileError) => {
                        console.error("Error fetching file content:", fileError.message);
                    });
            })
            .catch((error) => {
                if (error.response) {
                    console.error("Server responded with error:", error.response.status, error.response.data);
                    if (error.response.headers['content-type'] === 'application/json') {
                        alert("An error occurred: " + JSON.stringify(error.response.data));
                    }
                } else {
                    console.error("Error fetching file URL:", error.message);
                }
            });
    };


    renderForm() {
        return <div className="contact-wrap text-center">
            <div className="row justify-content-center">
                <ScrollAnimation animateIn='fadeInUp'>
                    <div className="section-heading text-center mb-4 heading-style">
                        <img
                            src={logo}
                            width={250}
                            alt="Lakshya 30 Logo"
                            className=" rounded"
                        />
                        <h3 className={'fw-bold'}>Lakshya 30 Exam Application Form</h3>
                    </div>
                </ScrollAnimation>
            </div>
            <form id="contact-form" role="form" onSubmit={this.submitApplicantForm}>
                <div className="row d-flex justify-content-center">
                    <div className="col-md-11 user__details">
                        <div className="input__box">
                            <span className="details">Student's Name | छात्र का नाम<span
                                className="text-danger"> *</span></span>
                            <input
                                type="text"
                                placeholder="E.g: Rahul Sharma"
                                name="studentName"
                                onChange={event => this.handleChange(event)}
                                required
                            />
                        </div>
                        <div className="input__box">
                            <span className="details">Father's Name | पिता का नाम</span>
                            <input
                                type="text"
                                placeholder="E.g: Vijay Sharma"
                                name="fatherName"
                                onChange={event => this.handleChange(event)}
                            />
                        </div>
                        <div className="input__box">
                                    <span className="details">Email | ईमेल<span
                                        className={'text-danger'}> *</span> </span>
                            <input type="email" placeholder="rahulsharma@gmail.com" name={"email"}
                                   onChange={event => this.handleChange(event)} required/>
                        </div>
                        <div className="input__box">
                            <span className="details">Pass out Class | उत्तीर्ण कक्षा</span>
                            <select
                                name="passOutClass"
                                onChange={event => this.handleChange(event)}
                                className="input" // Assuming the previous CSS for input works here
                                defaultValue=""
                            >
                                <option value="" disabled>Select Class</option>
                                <option value="8">8th</option>
                                <option value="9">9th</option>
                                <option value="10">10th</option>
                                <option value="11">11th</option>
                                <option value="12">12th</option>
                            </select>
                        </div>
                        <div className="input__box">
                            <span className="details">School Name | विद्यालय का नाम</span>
                            <input
                                type="text"
                                placeholder="School Name"
                                name="schoolName"
                                value={this.state.schoolName || ''}
                                onChange={(event) => {
                                    const value = event.target.value;
                                    if (/^[A-Za-z\s]*$/.test(value)) {
                                        this.setState({schoolName: value});
                                    }
                                }}
                            />
                        </div>
                        <div className="input__box">
                                    <span className="details">Phone Number | मोबाइल<span
                                        className={'text-danger'}> *</span></span>
                            <input
                                type="tel"
                                className="input"
                                placeholder="98*** ***18"
                                name="mobile"
                                required
                                pattern="[0-9]{10}" // Ensures exactly 10 digits
                                maxLength={10} // Prevents input beyond 10 characters
                                onInvalid={(event) => {
                                    const target = event.target as HTMLInputElement; // Type assertion
                                    target.setCustomValidity("10 digits required");
                                }}
                                onInput={(event) => {
                                    const target = event.target as HTMLInputElement; // Type assertion
                                    target.setCustomValidity(""); // Clear custom error message
                                    target.value = target.value.replace(/[^0-9]/g, ""); // Allow only digits
                                }}
                                onChange={(event) => this.handleChange(event)}
                            />
                        </div>
                        <div className="input__box">
                            <span className="details">Address | पता</span>
                            <input type="text" placeholder="E.g: Near Balaji Mandir" name={"address"}
                                   onChange={event => this.handleChange(event)}/>
                        </div>
                        <div className="input__box">
                            <span className="details">State | राज्य <span className="text-danger">*</span></span>
                            <select
                                name="state"
                                className="input w-full border p-2 rounded"
                                value={this.state.selectedState}
                                onChange={this.handleStateChange}
                                required
                            >
                                <option value="">Select State / राज्य चुनें</option>
                                {Object.keys(this.stateCityData).map((state) => (
                                    <option key={state} value={state}>{state}</option>
                                ))}
                            </select>
                        </div>
                        <div className="input__box">
                            <span className="details">City | शहर</span>
                            <select
                                name="city"
                                className="input w-full border p-2 rounded"
                                disabled={!this.state.selectedState}
                                value={this.state.city}
                                onChange={this.handleCityChange}
                                required
                            >
                                <option value="">Select City / शहर चुनें</option>
                                {this.state.cities.map((city) => (
                                    <option key={city} value={city}>{city}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className={'d-flex justify-content-center mt-3'}>
                        <LoaderButton loading={this.state.processing}
                                      label={'Submit Form'}
                                      cssName={"btn theme_btn w-100"}/>
                    </div>
                </div>

            </form>
        </div>
    }

    renderSuccessScreen() {
        const {admitCardURL} = this.state;
        console.log('273 ->>>>>', admitCardURL);

        return (
            <div className="text-center contact-wrap">
                <h2 className="text-success">Congratulations!</h2>
                <p>Your lakshya 30 Exam form has been successfully submitted. Here is your Admit Card:</p>

                {admitCardURL ? (
                    <div style={{height: '500px', width: '100%'}}>
                        <iframe
                            src={`https://docs.google.com/viewer?url=${encodeURIComponent(admitCardURL)}&embedded=true`}
                            title="PDF Preview"
                            width="80%"
                            height="100%"
                            style={{border: 'none'}}
                        ></iframe>

                    </div>
                ) : (
                    <p className="text-danger">Admit Card preview is unavailable.</p>
                )}
                <div
                    onClick={this.downloadAdmitCard} // Add onClick handler to trigger download
                    className="mx-3 d-flex justify-content-center mt-3 button button_theme py-2 text-white overflow-hidden position-relative"
                    style={{cursor: "pointer"}} // Adding cursor pointer to make it clear it's clickable
                >
                    <i className="bi bi-download mt-1"></i>
                    <LoaderButton
                        loading={this.state.processing}
                        label={"Download Admit Card"}
                        cssName={"btn button_theme"}
                    />
                </div>
            </div>
        );
    }

    render() {
        return (
            <section
                id={this.props.htmlId}
                className={`${this.props.themeClass} testingFontFamily`}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            {this.state.messageSent ? this.renderSuccessScreen() : this.renderForm()}
                        </div>
                        <div className="col-md-6 d-flex align-items-baseline mt-5">
                            <img src={applicationFormImg} className="w-100 rounded h-75 mt-1"/>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default ApplicationForm